module.exports = __webpack_public_path__ + "static/media/Clouds.ca6d342b.png";